import React from 'react';

import FilterWeb from './FilterWeb/FilterWeb';
import PropTypes from 'prop-types';

const Filters = ({ filters, clicked }) => {
  return <FilterWeb filters={filters} clicked={clicked} />;
};
Filters.propTypes = {
  filters: PropTypes.arrayOf(PropTypes.object),
  clicked: PropTypes.func,
};
export default Filters;
